import React, {useRef, useState} from 'react';
import {Button, DatePicker, Input, InputNumber, Form, FormProps} from 'antd';
import {FieldType} from './types';

type HashResponse = {
  hashExtended: string;
  timezone: string;
  storename: string;
  currency: string;
  txnDateTime: string;
  responseFailURL: string;
  responseSuccessURL: string;
}

async function fetchHash(values: FieldType): Promise<HashResponse> {

  try{
  const response = await fetch(`${process.env.APP_BASE_URL}/api/generate`, {
    method: 'POST',
    //mode: 'no-cors',
    body: JSON.stringify({
      ...values
    }),
  });

  const data = await response.json();
  return data;
  } catch (error) {
    console.error('Error fetching hash', error);
    return error;
  }
}

function App() {
   const [form] = Form.useForm();
   const [loading, setLoading] = useState(false);
   const hiddenFormRef = useRef<HTMLFormElement | null>(null);

   const handleFormSubmit: FormProps <FieldType > ['onFinish'] = async (values) => {

     setLoading(true);

     const response = await fetchHash(values);

     if (response) {
       // Set the values of the hidden form
       Object.keys(response).forEach(key => {
         if (hiddenFormRef.current !== null){
           if (hiddenFormRef.current[key]) {
             hiddenFormRef.current[key].value = response[key];
           }
         }
       });

       if (hiddenFormRef.current !== null) {
         console.log('submitting form')
         hiddenFormRef.current.submit();

        /*
         if (hiddenFormRef.current !== null) {
           const formData = new FormData(hiddenFormRef.current);

           fetch('https://test.ipg-online.com/connect/gateway/processing', {
             method: 'POST',
             mode: 'no-cors',
             body: formData,
           })
               .then(response => {
                 // You can inspect the response here
                 console.log(response);
               })
               .catch(error => {
                 console.error('Error:', error);
               });
         }

         */




         setLoading(false);
       }
     }
   }

    return (
        <div className={'max-w-xl mx-auto'}>
          <Form name="payment" id={'payment'} form={form}
                layout="vertical"
                onFinish={(data) => handleFormSubmit(data)}
                className={'flex flex-col space-y-2'}
                initialValues={{
                  txntype: 'sale',
                  hash_algorithm: 'HMACSHA256',
                  checkoutoption: 'combinedpage',
                  paymentMethod: 'M',
                  currency: '826'
                }}

          >
            <Form.Item name="responseSuccessURL" noStyle>
              <Input type="hidden"/>
            </Form.Item>

            <Form.Item name="responseFailURL" noStyle>
              <Input type="hidden"/>
            </Form.Item>

            <Form.Item name="txntype" noStyle>
              <Input defaultValue="sale"  type="hidden"/>
            </Form.Item>

            <Form.Item name="timezone" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="txndatetime" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="hash_algorithm" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="hashExtended" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="storename" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="checkoutoption" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="paymentMethod" noStyle>
              <Input  type="hidden"/>
            </Form.Item>

            <Form.Item name="currency" noStyle>
              <Input  type="hidden"/>
            </Form.Item>
            <Form.Item
                label="Patient Name"
                name="bname"
                rules={[{required: true, message: 'Please input your name!'}]}
            >
            <Input className={'w-full rounded-none p-2'} />
            </Form.Item>
            <Form.Item label="Email Address" name="email"
                       rules={[
                           {required: true, message: 'Please input a valid email address!'},
                           {type: 'email', message: 'Please input a valid email address!'}
                       ]}
            >
              <Input placeholder="" type="email" className={'w-full rounded-none p-2'}/>
            </Form.Item>
            <Form.Item label="Amount" name="chargetotal"
                       rules={[
                           {required: true, message: 'Please input the amount as per invoice!'},
                         {
                           pattern: /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/,
                           message: 'Please enter a valid amount as a number with two decimal places, using either a dot or a comma as the decimal separator (e.g., 1234.56 or 1234,56).'
                         }
                       ]}
            >
              <InputNumber prefix="£"
                           formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                           parser={(value) => value?.replace(/\$\s?|(,*)/g, '') as unknown as number}
                           className={'w-full rounded-none  p-1 pl-2'}
              />
            </Form.Item>
            <Form.Item label="Reference Number" name="invoicenumber"
                        rules={[{required: true, message: 'Please input the reference number as per invoice!'}]}
            >
              <Input type="text" className={'w-full rounded-none p-2'}/>
            </Form.Item>
            <div className={'pt-5'}>
              <Button htmlType="submit" size={'large'} loading={loading} className={'bg-nhs text-white rounded-none'}>Submit</Button>
            </div>
          </Form>

          {/* Hidden form */}
          <form
              ref={hiddenFormRef}
              action={process.env.GATEWAY_PROCESSING_URL}
              method="POST"
              style={{display: 'none'}}
          >
            <input name="responseSuccessURL"/>
            <input name="responseFailURL"/>
            <input name="txntype"/>
            <input name="timezone"/>
            <input name="txndatetime"/>
            <input name="hash_algorithm"/>
            <input name="hashExtended"/>
            <input name="storename"/>
            <input name="checkoutoption"/>
            <input name="paymentMethod"/>
            <input name="currency"/>
            <input name="chargetotal"/>
            <input name="bname"/>
            <input name="email"/>
            <input name="invoicenumber"/>
          </form>
        </div>
    );
}

export default App;
